import * as React from "react";
import SEO from "../components/SEO/Seo";
import Layout from "../Layouts/MasterLayout/MasterLayout";
import BeneficioCard from "../components/BeneficioCard/BeneficioCard";

import "../components/Css/descontos.css";

// Os textos, valores e destinos dos links abaixo foram mantidos da página anterior.
const beneficios = [
	{
		id: "primeira-mensalidade",
		titulo: "PRIMEIRA MENSALIDADE GRÁTIS NA GRADUAÇÃO EAD",
		destaque: true,
		amplo: true,
		conteudo: <p>Acesse o regulamento.</p>,
		acoes: [
			{
				texto: "Acesse",
				href: "https://www.feevale.br/divulgacao/2026/black-summit/index.html",
			},
		],
	},
	{
		id: "seguranca-publica",
		titulo: "PARA SERVIDORES DA SEGURANÇA PÚBLICA",
		amplo: true,
		conteudo: (
			<>
				<p>
					A Universidade Feevale oferece{" "}
					<b>descontos exclusivos nas mensalidades</b> dos cursos de{" "}
					<b>Direito e Psicologia</b> para integrantes da{" "}
					<b>Brigada Militar, Polícia Civil, Corpo de Bombeiros e Guarda Municipal.</b>
				</p>
				<ul>
					<li><b>Direito:</b> até <b>60% de desconto</b> conforme o número de créditos contratados.</li>
					<li><b>Psicologia:</b> até <b>50% de desconto</b> conforme o número de créditos contratados.</li>
				</ul>
				<p>
					Aproveite essa oportunidade e inicie sua graduação com benefícios especiais a partir do semestre <b>2026/01</b>.
				</p>
			</>
		),
		acoes: [
			{ texto: "Inscreva-se", href: "https://graduacao.feevale.br/inscrevase" },
			{ texto: "Edital 2026/02", href: "https://www.feevale.br/s/conteudo/5122fafd-02a1-400d-9e6f-b1fa7bbdfb65/Regulamento_04.2026_Seguran%c3%a7a_P%c3%bablica_2026.02.pdf", secundario: true },
			{ texto: "Edital 2026/01", href: "https://www.feevale.br/s/conteudo/8712f9ef-4957-4161-a946-10b213186277/Regulamento_Seguran%C3%A7a_P%C3%BAblica_2026.01__(1).pdf", secundario: true },
		],
	},
	{
		id: "extravestibular",
		titulo: "EXTRAVESTIBULAR",
		amplo: true,
		conteudo: (
			<p>Descontos destinados à transferência de curso, reingresso, portadores de diploma, estudantes evadidos e Programa 35+.</p>
		),
		acoes: [
			{ texto: "Acesse", href: "https://conteudo.feevale.br/extravestibular24" },
		],
	},
	{
		id: "servidores-publicos",
		titulo: "PARA SERVIDORES PÚBLICOS",
		conteudo: (
			<>
				<p>
					25% de desconto no valor do crédito para os cursos contratados por crédito ou 15%
					de desconto no valor do módulo para os cursos contratados por módulo.
					Destinado aos cursos de graduação para funcionários das seguintes corporações
					e que tenham firmado convênio de parceria com a Instituição:
				</p>
				<ul>
					<li>Brigada Militar</li>
					<li>Polícia Civil</li>
					<li>Corpo de Bombeiros</li>
					<li>Guarda Municipal</li>
				</ul>
			</>
		),
		acoes: [
			{ texto: "Mais informações", href: "https://www.feevale.br/institucional/atendimento-feevale" },
			{ texto: "Regulamento", href: "https://www.feevale.br/s/conteudo/c8360c27-140d-46ac-9c26-ff0e957cf06b/02-_Plano_de_incentivo_a_gradua%c3%a7%c3%a3o_02.01.24__assinado(1)_1.pdf", secundario: true },
		],
	},
	{
		id: "educadores",
		titulo: "PARA EDUCADORES",
		conteudo: (
			<p>
				40% de desconto para os cursos contratados por crédito ou 30%
				de desconto para os cursos contratados por módulos.
				Destinado aos cursos licenciatura para professores sem formação
				superior, vinculados à Secretaria Estadual de Educação do
				Estado do Rio Grande do Sul, por meio das Cordenadorias
				Regionais de Educação (CREs), e às Secretarias Municipais de
				Educação (SMEDs) dos municípios da região que firmarem
				parceria com a Universidade.
			</p>
		),
		acoes: [
			{ texto: "Mais informações", href: "https://www.feevale.br/institucional/atendimento-feevale" },
		],
	},
	{
		id: "prouni",
		titulo: "INGRESSE PELO PROUNI",
		amplo: true,
		conteudo: <p>A Universidade Feevale oferece oportunidades de ingresso através do PROUNI.</p>,
		acoes: [
			{ texto: "Saiba mais", href: "https://www.feevale.br/todas-as-oportunidades/prouni" },
		],
	},
	{
		id: "familia",
		titulo: "Auxílio Família",
		amplo: true,
		conteudo: (
			<p>
				Desconto de 5% concedido aos acadêmicos de graduação com mais
				de um familiar – irmão, filho, esposo(a), matriculados
				regularmente e simultaneamente na Instituição, em cursos de
				Graduação, Pós-Graduação Lato Sensu, Educação Infantil, Ensino
				Fundamental e Médio.
			</p>
		),
	},
	{
		id: "extensao",
		titulo: "BOLSAS DE EXTENSÃO",
		conteudo: <p>Atue em projetos sociais em andamento na Instituição e receba créditos acadêmicos.</p>,
	},
	{
		id: "iniciacao-cientifica",
		titulo: "BOLSAS DE INICIAÇÃO CIENTÍFICA",
		conteudo: <p>Atue em projetos de pesquisa em andamento na Instituição e receba créditos acadêmicos.</p>,
	},
	{
		id: "monitorias",
		titulo: "MONITORIAS",
		conteudo: <p>Atue com monitoria em disciplinas e receba créditos acadêmicos.</p>,
	},
	{
		id: "perda-emprego",
		titulo: "BOLSA POR PERDA DE EMPREGO",
		amplo: true,
		conteudo: (
			<p>
				Bolsa que garante a continuidade do pagamento das mensalidades
				para os alunos matriculados na Instituição que foram
				dispensados sem justa causa do emprego. A bolsa é limitada ao
				valor do salário, pelo período de até três meses. Para mais
				informações, consulte as regras e critérios de concessão do
				benefício, no Guia Acadêmico.
			</p>
		),
	},
];

export default function DescontosPage() {
	return (
		<Layout color="#fff">
			<SEO
				title="Vantagens para ingressar"
				description="Conheça as vantagens para ingressar na Universidade Feevale. Bolsas e descontos."
			/>

			<main className="descontosPage">
				<header className="descontosPage-hero">
					<div className="container">
						<h1>Bolsas e descontos</h1>
					</div>
				</header>

				<section className="descontosPage-lista" aria-label="Benefícios e descontos">
					<div className="container">
						<div className="descontosPage-grid">
							{beneficios.map((beneficio) => (
							<BeneficioCard
								key={beneficio.id}
								titulo={beneficio.titulo}
								acoes={beneficio.acoes}
								destaque={beneficio.destaque}
								amplo={beneficio.amplo}
							>
								{beneficio.conteudo}
							</BeneficioCard>
							))}
						</div>
					</div>
				</section>

				<section className="descontosPage-oportunidades">
					<div className="container descontosPage-oportunidadesConteudo">
						<p>
							Para ajudar a manter seus estudos, ao ingressar na Universidade
							Feevale você conta com um portal exclusivo para graduando(a)
							repleto de vagas de emprego e estágios e também outras bolsas.
							Toda semana surgem novas oportunidades e você pode candidatar-se.
						</p>
						<a
							href="https://www.feevale.br/oportunidades"
							target="_blank"
							rel="noopener noreferrer"
							className="descontosPage-oportunidadesBtn"
						>
							Acesse
						</a>
					</div>
				</section>
			</main>
		</Layout>
	);
}
